import { RefreshCircle as RefreshCircular } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconRefreshCircular12Line = createIcon(
  RefreshCircular,
  12,
  "Line"
);
export const IconRefreshCircular16Line = createIcon(
  RefreshCircular,
  16,
  "Line"
);
export const IconRefreshCircular20Line = createIcon(
  RefreshCircular,
  20,
  "Line"
);
export const IconRefreshCircular24Line = createIcon(
  RefreshCircular,
  24,
  "Line"
);
export const IconRefreshCircular32Line = createIcon(
  RefreshCircular,
  32,
  "Line"
);
export const IconRefreshCircular48Line = createIcon(
  RefreshCircular,
  48,
  "Line"
);
export const IconRefreshCircular64Line = createIcon(
  RefreshCircular,
  64,
  "Line"
);
